import React, { useContext } from 'react';
import { Container } from '../Retencion.styles';
import { GridContainer, GridItem } from 'src/components/common/grids';
import OrderInput from 'src/components/common/OrderInput/OrderInput';
import CostumerService from '../CostumerService/CostumerService';
import TableHeader from 'src/components/common/TableHeader/TableHeader';
import UserData from '../UserData/UserData';
import UserInfo from '../UserInfo/UserInfo';
import Notes from '../Notes/Notes';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { Results404 } from '../Results404/Results404';
import { createTicketExpandValidity, updateTicketExpandValidity } from 'src/redux/expand_validity/thunks';
import { getAllExpandValidity } from 'src/redux/expand_validity/slice';
import { TabBarContext } from 'src/components/common/TabSwich';
import { configFile } from '../Retention.constants';

const CheckTabList = (tab: string) => {
    const isUserRetention = tab === configFile[1].tab;
    return [
        {
            id: '1',
            label: 'Costumer Service',
            Component: CostumerService,
            col: 3,
            md_col: 2,
        },
        {
            id: '2',
            label: 'Datos del usuario',
            Component: UserData,
            col: 3,
            md_col: 2,
        },
        {
            id: '3',
            label: 'Información del usuario',
            Component: UserInfo,
            col: 3,
            md_col: 2,
        },
        {
            id: '4',
            label: isUserRetention ? 'Score del usuario' : 'Notas',
            Component: Notes,
            col: 3,
            md_col: 2,
        },
    ];
}

const ExpandValidityList = () => {
    const list = useAppSelector(getAllExpandValidity);
    const loading = useAppSelector((state) => state.UI.loading);
    const hasData = list?.length > 0;
    const { activeTab } = useContext(TabBarContext);
    const dispatch = useAppDispatch();

    const handleOnChange = ({ value, name, id, ticket_id, user_id }) => {
        if (!ticket_id) {
            dispatch(createTicketExpandValidity({ id, user_id, [name]: value }));
        } else {
            dispatch(updateTicketExpandValidity({ id, ticket_id, user_id, [name]: value }));
        }
    };

    return (


        <>
            <TableHeader arrayHeaders={CheckTabList(activeTab)} />
            {loading && !hasData ? (
                [...Array(5)].map((_, i) => (
                    <Container key={i}>
                        <GridContainer p-sm="0px">
                            {CheckTabList(activeTab).map(({ id, label, Component }) => (
                                <React.Fragment key={id}>
                                    <GridItem lg-d-none className="header_table">
                                        <OrderInput label={label} />
                                    </GridItem>
                                    <GridItem md={8} lg={3}>
                                        <Component {
                                            ...{
                                                loading,
                                                isUserRetention: activeTab === configFile[1].tab,
                                                data: null
                                            }
                                        } />
                                    </GridItem>
                                </React.Fragment>
                            ))}
                        </GridContainer>
                    </Container>
                ))
            ) : (
                <>
                    {hasData ?
                        list.map((item) => (
                            <Container key={item.user_id}>
                                <GridContainer p-sm="0px">
                                    {CheckTabList(activeTab).map(({ id, label, Component }) => (
                                        <React.Fragment key={id}>
                                            <GridItem lg-d-none className="header_table">
                                                <OrderInput label={label} />
                                            </GridItem>
                                            <GridItem md={8} lg={3}>
                                                <Component {...{
                                                    loading,
                                                    isUserRetention: activeTab === configFile[1].tab,
                                                    data: item,
                                                    onChange: handleOnChange
                                                }} />
                                            </GridItem>
                                        </React.Fragment>
                                    ))}
                                </GridContainer>
                            </Container>
                        )) : <Results404 />}
                </>
            )}
        </>
    );
};

export default ExpandValidityList;
